import { render } from "./DashboardPoSo.vue?vue&type=template&id=23aa4d0e"
import script from "./DashboardPoSo.vue?vue&type=script&lang=js"
export * from "./DashboardPoSo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__